module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_about_sas-4a0875284c7a13082ca771446a443261.png";